/** Product feedback for founding vendors and operators building with PNN. */
export const PRODUCT_FEEDBACK_EMAIL =
  process.env.NEXT_PUBLIC_SUPPORT_EMAIL || "support@pacificnorthnorth.com";

export function getProductFeedbackMailtoHref(vendorBusinessName?: string): string {
  const subject = encodeURIComponent("PNN Product Feedback (Founding Vendor)");
  const bodyLines = [
    "Business name:",
    vendorBusinessName?.trim() || "(your business)",
    "",
    "What I was trying to do:",
    "",
    "What happened / where it got stuck:",
    "",
    "Priority: critical / important / nice to have",
    "",
    "(Attach screenshots in your email client if helpful)",
  ];
  const body = encodeURIComponent(bodyLines.join("\n"));
  return `mailto:${PRODUCT_FEEDBACK_EMAIL}?subject=${subject}&body=${body}`;
}
